import script from "./UserInfoUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfoUpdate.vue?vue&type=script&setup=true&lang=js"

import "./UserInfoUpdate.vue?vue&type=style&index=0&id=1f27cc6c&lang=scss&scoped=true"

import exportComponent from "/home/ecs-user/software/jenkins/workspace/smallshop-website-uat/smallshop-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f27cc6c"]])

export default __exports__